import { reviewTypes } from '../types';
import { getList, save } from '../services/review';
import { messageTime } from 'config'

import { showMessage } from './message';

export const addReview = (review) => async (dispatch) => {
    dispatch({
        type: reviewTypes.ADD_REQUEST,
        ...review,
    });

    const { productId } = review;

    save(review)
        .then((review) => {
            dispatch({
                type: reviewTypes.ADD_SUCCESS,
                review,
            });

            dispatch(
                showMessage({
                    textId: 'reviewSuccess',
                    target: 'inside',
                    targetId: productId,
                }),
            );

            return review;
        })
        .then((review) => {
            setTimeout(() => {
                dispatch(getReviewList());
            }, messageTime);
            return review;
        })
        .catch((error) => {
            console.error(error);
            dispatch({
                type: reviewTypes.ADD_ERROR,
                error,
            });
        });
};

export const getReviewList = (page) => async (dispatch) => {
    dispatch({
        type: reviewTypes.LOAD_REQUEST,
    });

    return getList({ page })
        .then((payload) => {
            dispatch({ type: reviewTypes.LOAD_SUCCESS, payload });

            return payload;
        })
        .catch((error) => {
            console.error(error);
            dispatch({
                type: reviewTypes.LOAD_ERROR,
                error,
            });
        });
};

export const clearData = async (dispatch) => dispatch({ type: reviewTypes.CLEAR });
